import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {defaultAlert} from "../../utils/alert";
import {verifyPaymentPassword} from '../../api/commonApi';
import {usePaymentAuth} from "../../routes/ProtectedRoute";
import {processPayment} from '../../api/transaction/payApi';
interface LocationState {
    onSuccess?: () => void | Promise<void>;
    title?: string;
    subtitle?: string;
    returnPath?: string;
    paymentData?: any;
    password?: string;
}

const PasswordPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as LocationState;
    const {setPaymentAuthed} = usePaymentAuth();

    const [password, setPassword] = useState('');
    const [numbers, setNumbers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]);
    const [isLoading, setIsLoading] = useState(false);

    const handleNumberClick = (num: number) => {
        if (password.length < 6 && !isLoading) {
            const newPassword = password + num;
            setPassword(newPassword);

            if (newPassword.length === 6) {
                handleSubmit(newPassword);
            }
        }
    };

    const handleDelete = () => {
        if (!isLoading) {
            setPassword(password.slice(0, -1));
        }
    };

    const handleShuffle = () => {
        if (!isLoading) {
            const shuffled = [...numbers].sort(() => Math.random() - 0.5);
            setNumbers(shuffled);
        }
    };
    const handleSubmit = async (password: string) => {
        setIsLoading(true);

        try {
            const response = await verifyPaymentPassword({ password: password });
            if (response.data.data === true) {
                setPaymentAuthed(true);

                // paymentData가 있으면 결제 처리
                if (state?.paymentData) {
                    // 결제 완료 후 공고 상세 페이지로 리다이렉트하기 위해 jobPostingCode 저장
                    if (state.paymentData.jobPostingCode) {
                        sessionStorage.setItem('jobPostingCode', state.paymentData.jobPostingCode);
                    }
                    await processPayment(state.paymentData);
                }

                setTimeout(() => {
                    if (state?.returnPath) {
                        navigate(state.returnPath, { replace: true });
                    } else {
                        navigate('/wallet/charge', { replace: true });
                    }
                }, 0);
            } else {
                defaultAlert('비밀번호가 일치하지 않습니다.');
                setPassword('');
            }
        } catch (error: any) {
            if (error.response?.status === 403) {
                defaultAlert('비밀번호가 일치하지 않습니다.');
            } else {
                defaultAlert('비밀번호 확인에 실패했습니다.');
            }
            setPassword('');
        } finally {
            setIsLoading(false);
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    const passwordIndicators = Array.from({length: 6}, (_, i) => i);

    return (
        <>
            <header className="sub-header">
                <div className="header-inner">
                    <button
                        type="button"
                        className="closeBtn"
                        onClick={handleBack}
                        disabled={isLoading}
                    >
                        <span className="blind">닫기</span>
                    </button>
                </div>
            </header>

            <main className="container no-bottom-nav">
                <section>
                    <div className="passwordForm">
                        <h1>{state?.title || '결제비밀번호 입력'}</h1>
                        <h2>{state?.subtitle || '결제비밀번호 6자리를 입력해 주세요.'}</h2>
                        <div className="password-input inlinePassword-input">
                            <div className="password-indicator">
                                {passwordIndicators.map((i) => (
                                    <span
                                        key={i}
                                        className={`passCircle ${i < password.length ? 'filled' : ''}`}
                                        id={`passwd${i}`}
                                    />
                                ))}
                            </div>
                        </div>
                        {isLoading && <p className="loading-text">처리 중...</p>}
                    </div>
                </section>

                <section>
                    <div className="fixedBottom">
                        <ul className="keyboardF">
                            {numbers.slice(0, 9).map((num) => (
                                <li key={num}>
                                    <button
                                        type="button"
                                        className="key-btn"
                                        onClick={() => handleNumberClick(num)}
                                        disabled={isLoading}
                                    >
                                        {num}
                                    </button>
                                </li>
                            ))}
                            <li>
                                <button
                                    type="button"
                                    className="key-btn txt"
                                    onClick={handleShuffle}
                                    disabled={isLoading}
                                >
                                    재배열
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    className="key-btn"
                                    onClick={() => handleNumberClick(numbers[9])}
                                    disabled={isLoading}
                                >
                                    {numbers[9]}
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    className="key-btn txt"
                                    onClick={handleDelete}
                                    disabled={isLoading}
                                >
                                    삭제
                                </button>
                            </li>
                        </ul>
                    </div>
                </section>
            </main>
        </>
    );
};

export default PasswordPage;